// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__csErn","item":"ContactList_item__EZYHO","name":"ContactList_name__UCkFW","phone":"ContactList_phone__dbg3i","button":"ContactList_button__7kL4l"};